import {effect, Injectable, signal, Type, WritableSignal} from '@angular/core';
import { filter } from "rxjs";
import { NavigationEnd, Router } from "@angular/router";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";

@Injectable({ providedIn: 'root' })
export class PageHeaderService {
  headers: WritableSignal<HeaderConfig[]> = signal([]);
  actions: WritableSignal<Record<string, Function>> = signal({});
  headers_instances: WritableSignal<any[]> = signal([]);

  constructor(private router: Router) {
    // auto cleanup headers
    this.router.events.pipe(
      takeUntilDestroyed(),
      filter(e => e instanceof NavigationEnd)
    ).subscribe({
      next: () => this.clearHeaders(),
    })
  }

  public addHeader(component: Type<any>, inputs: Record<string, any> = {}) {
    this.headers.update(h => [...h, { component, inputs }]);
  }

  public clearHeaders() {
    this.headers.set([]);
    this.actions.set({});
    this.headers_instances.set([]);
  }

  public registerAction(action: string, fn: Function) {
    this.actions.update(a => ({ ...a, [action]: fn }));
  }

  public execute(action: string, args?: any) {
    const fn = this.actions()[action];
    if (fn) fn(args);
  }
  public storeInstance(component: any){
    this.headers_instances.update(i=>([...i,component]))
  }
  public getInstance(component: any){
    return this.headers_instances().find(i=> i instanceof component);
  }
  public removeInstance(instance: any){
   this.headers_instances.update(i=> i.filter(e=> e != instance));
  }
}

interface HeaderConfig {
  component: Type<any>;
  inputs?: Record<string, any>;
}
